import { DateField, Labeled, ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const SpecialistGraduationInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Информация за завършено висше образование"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={3}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Университет">
            <TextField
              source="graduationInfo.university"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Сертификат за признаване на висше образование">
            <TextField
              source="graduationInfo.higherEducationRecognitionCert"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Сертификат за признаване на квалификация">
            <TextField
              source="graduationInfo.qualificationRecognitionCert"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="graduationInfo.graduationSpecialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
              emptyText="-"
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Квалификационна степен">
            <ReferenceField
              source="graduationInfo.graduationDegreeId"
              reference={administrationRequests.getDegreesSelect()}
              emptyText="-"
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Регистрационен номер на диплома">
            <TextField
              source="graduationInfo.diplomaRegistrationNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Серия на диплома">
            <TextField
              source="graduationInfo.diplomaSeries"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Номер на диплома">
            <TextField
              source="graduationInfo.diplomaNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Дата на диплома">
            <DateField
              source="graduationInfo.diplomaDate"
              locales="bg-BG"
              showTime={false}
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default SpecialistGraduationInfoSection;
